module.exports = __webpack_public_path__ + "static/img/usdt.759aaeea.png";